import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../api/axios';
import { AdminPageHeader, AdminTableCard } from './AdminUi';
import './admin.css';

export default function AdminPosts() {
  const [q, setQ] = useState('');
  const [data, setData] = useState({ total: 0, results: [] });
  const [loading, setLoading] = useState(true);

  const load = (search = q) => {
    setLoading(true);
    api.get('admin/posts/', { params: { q: search || undefined, limit: 100 } })
      .then((r) => setData(r.data))
      .catch((e) => toast.error(e.response?.data?.error || 'Failed'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(''); }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this post and its comments/likes?')) return;
    await api.delete(`admin/posts/${id}/`);
    toast.success('Post deleted');
    load();
  };

  return (
    <div>
      <AdminPageHeader title="Social Posts" subtitle={`${data.total} posts`}>
        <form className="d-flex gap-2" onSubmit={(e) => { e.preventDefault(); load(q); }}>
          <input className="form-control" placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} />
          <button className="btn btn-primary rounded-pill px-3" type="submit">Search</button>
        </form>
      </AdminPageHeader>

      {loading ? (
        <div className="text-center py-5"><div className="spinner-border text-primary" /></div>
      ) : (
        <AdminTableCard>
          <table className="admin-table admin-table-posts">
            <thead>
              <tr>
                <th>Title</th>
                <th>Doctor</th>
                <th>Likes</th>
                <th>Comments</th>
                <th>Saves</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.results.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center text-muted py-4">No posts found</td>
                </tr>
              ) : (
                data.results.map((p) => {
                  const title = p.title || '(untitled)';
                  return (
                    <tr key={p.id}>
                      <td>
                        <div className="admin-posts-title-row">
                          {p.image ? (
                            <img src={p.image} alt="" className="admin-posts-thumb" />
                          ) : null}
                          <div className="admin-posts-title-text">
                            <div className="fw-semibold text-truncate" title={title}>
                              {title}
                            </div>
                            {p.short_content ? (
                              <div className="small text-muted text-truncate" title={p.short_content}>
                                {p.short_content}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="admin-posts-doctor text-truncate" title={p.doctor_name || ''}>
                          {p.doctor_name || '—'}
                        </div>
                      </td>
                      <td className="admin-posts-num">{p.likes_count ?? 0}</td>
                      <td className="admin-posts-num">{p.comments_count ?? 0}</td>
                      <td className="admin-posts-num">{p.saves_count ?? 0}</td>
                      <td className="admin-posts-date small">
                        {p.created_at ? new Date(p.created_at).toLocaleDateString() : '—'}
                      </td>
                      <td className="admin-posts-actions">
                        <div className="admin-row-actions">
                          <Link
                            to={`/admin/posts/${p.id}`}
                            className="admin-action-btn view"
                            title="View full post"
                          >
                            <i className="bi bi-eye" />
                            <span>View</span>
                          </Link>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger rounded-pill px-3"
                            onClick={() => remove(p.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </AdminTableCard>
      )}
    </div>
  );
}
